module.exports = __webpack_public_path__ + "fonts/fa-brands-400.4b115e1.woff2";